import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ProcessingStatus, IProcessingStatus } from 'app_sasha/shared/resources/processings/ProcessingStatus';

@Component({
    selector: 'expandable-processing-status',
    template: `
    <div>
        <processing-status-list
            *ngIf="expand"
            class="status-expended col-to-row-s-tb flex-1 ctn-right"
            [status]="statusList">
        </processing-status-list>
        <processing-status
            *ngIf="!expand"
            class="status-abstract col-to-row-s-tb flex-1 ctn-right"
            [name]="summary.name"
            [count]="summary.count"
            [total]="total">
        </processing-status>
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableProcessingStatusComponent  {
    @Input()
    public statusList: IProcessingStatus;

    @Input()
    public expand: boolean = false;

    public get summary(): {name: string, count: number}{
        const name: ProcessingStatus = this.mainStatus;

        return {
            name,
            count: this.statusList[name],
        };

    }

    private get mainStatus(): ProcessingStatus {
        if (this.statusList[ProcessingStatus.Error]){
            return ProcessingStatus.Error;
        }

        if (this.statusList[ProcessingStatus.Processing]){
            return ProcessingStatus.Processing;
        }

        if (this.statusList[ProcessingStatus.Pending]){
            return ProcessingStatus.Pending;
        }

        if (this.statusList[ProcessingStatus.Warning]){
            return ProcessingStatus.Warning;
        }

        if (this.statusList[ProcessingStatus.Success]){
            return ProcessingStatus.Success;
        }

        return ProcessingStatus.Pending;
    }

    public get total(): number {
        return Object.values(ProcessingStatus)
            .reduce((total: number, key: string) => {
                return total + (this.statusList[key] || 0);
            }, 0);
    }
}